import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AUTHENTICATION_KEY } from 'client/common';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem(AUTHENTICATION_KEY);
  const location = useLocation()
  if (!token) {
    return <Navigate to="/authentication/login" state={{ from: location }} />;
  }

  return children;
};

export default ProtectedRoute;
